import logo from './logo.svg';
import './App.css';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import Inicio from './pages/inicio';
import Compañia from './pages/compañia';
import Servicios from './pages/servicios';
import Contacto from './pages/contacto';
import Atletas from './pages/atletas';
import PerfilAtleta from './pages/perfilAtleta';
import NotFound from './pages/NotFound';
import APYGroupLayout from './layouts.jsx';

// Importamos el proveedor de idioma
import { LanguageProvider } from './LanguageContext';

function App() {
  return (
    // Envolvemos toda la aplicación con el proveedor de idioma
    <LanguageProvider>
      <Router>
        <APYGroupLayout>
          <Routes>
            <Route path="/" element={<Inicio />} />
            <Route path="/compania" element={<Compañia />} />
            <Route path="/atletas" element={<Atletas />} />
            <Route path="/atletas/:id" element={<PerfilAtleta />} />
            <Route path="/servicio" element={<Servicios />} />
            <Route path="/contacto" element={<Contacto />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </APYGroupLayout>
      </Router>
    </LanguageProvider>
  );
}

export default App;